import initialState from '../../data/mute'; // initial state
import ActionTypes from '../constants/action-types';
import store from '../reducers/reducer';

const messageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_MUTE': return { ...state, mute_val: action.mute_val };
        case 'UPDATE_MUTE_OTHER': return { ...state, mute_other_val: action.mute_other_val };
        case ActionTypes.SET_CONV_LIST:
            return {
                ...state,
                convList: action.convList
            };
        case ActionTypes.APPEND_CONV_LIST:
            return {
                ...state,
                convList: [...state.convList, ...action.convList]
            };
        case 'UPDATE_SHOW_PRICE': return { ...state, showPrice: action.showPrice };
        case 'UPDATE_SHOW_VERIFICATION': return { ...state, showVerification: action.showVerification };
        case 'UPDATE_SHOW_MSG_LOADER': return { ...state, showMsgLoader: action.showMsgLoader };
        case 'UPDATE_SHOW_IMAGE_MODAL': return { ...state, showImageModal: action.showImageModal };
        case 'UPDATE_IMAGE_MODAL_SRC': return { ...state, imageModalSrc: action.imageModalSrc };
        case 'UPDATE_VIDEO_PLAYBACK_CONTEXT': return { ...state, videoPlaybackContext: action.videoPlaybackContext };
        case 'UPDATE_SHOW_VIDEO_MODAL': return { ...state, showVideoModal: action.showVideoModal };
        case 'UPDATE_SHOW_BUNDLE_MODAL': return { ...state, showBundleModal: action.showBundleModal };
        case 'UPDATE_BUNDLE_MODAL_SRC': return { ...state, bundleModalSrc: action.bundleModalSrc };
        case 'UPDATE_BROADCAST_MESSAGE': return { ...state, broadcastMsg: action.broadcastMsg };
        case 'UPDATE_BUNDLE_INDEX': return { ...state, bundleIndex: action.bundleIndex };
        case 'UPDATE_ACTIVE_CONV': return { ...state, activeConv: action.activeConv };
        case 'UPDATE_MSG_OPTION_OPEN': return { ...state, msgOptionOpen: action.msgOptionOpen };
        case 'UPDATE_MSG_STATS':
            return {
                ...state,
                msgStats: action.msgStats
            };
        case 'UPDATE_TRIGGER_SCROLL_BOTTOM': return { ...state, triggerScrollBottom: action.triggerScrollBottom };
        case 'REORDER_CONV_LIST':  //for sending message
            const results = state.convList;
            const conv_list = results.slice();


            if (state.convIndex != 0) {
                const itemToMove = conv_list[state.convIndex];
                const itemToMoveArr = [itemToMove];

                const updated_conv_list = conv_list.filter((clist, index) => index != state.convIndex);
                const appended_conv_list = [...itemToMoveArr, ...updated_conv_list];

                return { ...state, convList: appended_conv_list };
            } else {
                return { ...state, convList: conv_list };
            }

        case 'REORDER_RECEIVE_CONV_LIST':  //for receiving message
            const results_r = state.convList;
            const conv_list_r = results_r.slice();

            conv_list_r[action.convIndex]['latest_message']['message'] = action.newMsg;
            conv_list_r[action.convIndex]['latest_message']['sender_id'] = action.message.sender_id;
            conv_list_r[action.convIndex]['latest_message']['rec_id'] = action.message.rec_id;
            conv_list_r[action.convIndex]['has_unread'] = 'yes';

            //don't reorder when already on top
            if (action.convIndex > 0) {
                const itemToMove_r = conv_list_r[action.convIndex];
                const itemToMoveArr_r = [itemToMove_r];

                const updated_conv_list_r = conv_list_r.filter((clist, index) => index != action.convIndex);
                const appended_conv_list_r = [...itemToMoveArr_r, ...updated_conv_list_r];


                return { ...state, convList: appended_conv_list_r };
            }

            return { ...state, convList: conv_list_r };


        case 'UPDATE_UNREAD_CONV_LIST':
            //console.log(action.newMsg);
            const results_u = state.convList;
            const conv_list_u = results_u.slice();
            conv_list_u[action.convIndex]['has_unread'] = 'no';

            return { ...state, convList: conv_list_u };

        case 'SET_CONV_INDEX': return { ...state, convIndex: action.convIndex };

        case 'SET_CONTAINER_CLASS': return { ...state, containerClass: action.payload };

        case ActionTypes.SET_STASH_MODAL: return { ...state, stashModal: action.payload };
        // case ActionTypes.SET_ACTIVE_ALBUM: return { ...state, activeAlbum: action.payload };
        case ActionTypes.SET_STASH_SIDEBAR: return { ...state, stashSidebar: action.payload };
        case ActionTypes.SET_BROADCAST_MODAL: return { ...state, broadcastModal: action.payload };
        case ActionTypes.SET_SIDEBAR_BUSY: return { ...state, sidebarBusy: action.payload };
        case ActionTypes.SET_MESSAGES: return { ...state, messages: action.payload };
        case ActionTypes.ADD_READ_MESSAGES:
            let tmp = [...state.read];
            tmp.push(action.payload);
            return { ...state, read: tmp };

        case ActionTypes.UPDATE_CONV_LIST_ONLINE_STATUS:
            let tmpConvList = [...state.convList];
            const userId = action.payload.user;

            let index = tmpConvList.findIndex(conversation => (conversation.follower == userId));

            if (index >= 0) {
                tmpConvList[index].su_online_status = action.payload.status;
            }

            index = tmpConvList.findIndex(conversation => (conversation.creator == userId));

            if (index >= 0) {
                tmpConvList[index].pu_online_status = action.payload.status;
            }

            return { ...state, convList: [...tmpConvList] };

        case ActionTypes.UPDATE_USER_FILTER:
            return {
                ...state,
                userFilter: action.payload
            };

        case ActionTypes.UPDATE_MESSENGER_SEARCH_FILTER:
            return {
                ...state,
                messengerSearchFilter: action.payload
            };

        case ActionTypes.UPDATE_BROADCAST_INDICATOR:
            return {
                ...state,
                broadcastIndicator: action.payload
            };

        case ActionTypes.SET_MESSAGE_USER_LISTS:
            return {
                ...state,
                userListsFilter: action.payload
            };
        case ActionTypes.RESET_MESSAGE_USER_LISTS:
            return {
                ...state,
                userListsFilter: []
            };
        case ActionTypes.SET_SHOW_MESSAGE_USER_LISTS:
            return {
                ...state,
                showUserLists: action.payload
            };

        default:
            return state;
    }
};

export default messageReducer;
